/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
const avatarTypes = ['photo', 'initials'];
export const isAvatarType = (value) => typeof value === 'string' && avatarTypes.includes(value);
export const avatarTypeConverter = (value, defaultValue = 'photo') => isAvatarType(value) ? value : defaultValue;
